import React, {Component} from 'react';
import {Input, Popover, Button, Tabs, Empty, Form, Upload, message, Spin, Modal,Icon,Popconfirm,DatePicker,Select } from 'antd';
import {getAllEmotionsList} from "../../actions/weiboEmotionsList";
import {EditableTagGroup} from "../editableTagGroup";
import {WeiboPicturesWall} from "./weiboPicturesWall";
import ReactDOM from 'react-dom';
import {uuid} from "../../utils";
import *as utils from "../../utils";
import {
    getWeiboByWeiboId,
    saveWeibo,
    saveStatusName,
    deleteWeibo,
    getRevokeWeibo,
    publishWeibo, getUserInfo
} from "../../actions/weiBo";
import {
    actData,
    actButton
} from "../activity/publicnew";
import {Scrollbars} from "react-custom-scrollbars";
import ChooseUserModal from "../../containers/chooseUserModal";
import {actInit} from "./editWeiboActiviti";
import {connect} from "react-redux";
import {activiti, Activiti} from "../activity/public";
import {getButtonByMediaCode} from "../../actions";
import *as actions from "../../actions/weiBo";
import time from'./img/time.png'
import place from'./img/place.png'
const { TextArea } = Input;
const { TabPane } = Tabs;
const { confirm } = Modal;
const { Option } = Select;
let taskPublishDate;
/** 节点数据 **/
let actTask = {
    lastId:null    //最后一个节点id，也就是当前所流转到的节点id
};

let win = window.top || window;

let sortBy = function (filed, rev, primer) {
    rev = (rev) ? -1 : 1;
    return function (a, b) {
        a = a[filed];
        b = b[filed];
        if (typeof (primer) != 'undefined') {
            a = primer(a);
            b = primer(b);
        }
        if (a < b) { return rev * -1; }
        if (a > b) { return rev * 1; }
        return 1;
    }
};

class EditWeiBo extends Component {
    currentUser;
    weiboId = this.props.weiboId || 0;
    fatherObj = this.props.fatherObj;
    statusNameTemp = "";
    statusName = "";
    textareaModalTitle = '备注';
    callbackType = '';
    publishUrl = '';
    weibo_mid = "";
    buttonRole = {};
    activitiObj ={};
    constructor(props)
    {
        super(props);
        this.state = {
            mediaCode: props.currentMedia,
            weiboId: props.weiboId,
            weiboUserName: "",
            type: "face",
            fontSize: 0,
            content: props.content,
            showNowStr : <span>输入</span>,
            emotionsDataSource: [],
            fileList:[],
            tags:[],
            btns:[],
            loading: false,
            textareaModalVisible : false,    // 撤稿的备注框
            uploadVisible: false,
            userNameVisible: false,
            htVisible: false,
            videoVisible: false,
            placeVisible: false,
            iconLoading: false,
            remarksContent: "",
            timingTransmission:"",//定时发送
            timeSelect:null,
            placeData: [],//定位类搜索
            placeValue: undefined,
            openPlace:false,
            topicData: [],//话题类搜索
            topicMenu:[],
            topicValue: undefined,
            topicId:'',
            openTopic:false,
            userNameData: [],//@名字搜索
            userNameValue: undefined,
            openUserName:false,
            isTouTiaoArticle:false,
            touTiaoArticleInfor:{},
            currentData:{},
            userInfo:{},
        };
        this.currentUser = this.props.currentUser;

        this.initButtonRole(()=>{
            this.initWeiboData();
        });
    }

    initButtonRole(callback)
    {
        getButtonByMediaCode([{"mediaCode": this.state.mediaCode}],(dataJson)=>{
            if(dataJson)
            {
                this.buttonRole = dataJson;
            }
            callback();
        });
    }

    callback = () => {};

    refreshList()
    {
        if(this.props.changeLoading){
            this.props.changeLoading(false);
        }
        if(this.props.fatherObj)
        {
            this.props.fatherObj.refreshList();
        }else {
            this.props.refreshList();
        }
    }

    onClick = (type, functions, weiboediter) => {
        this.openLoad();

        let that=this;
        if(type === "save"){
            //除过 定时发布 保存，都不可以携带定时器
            if((this.statusName != '定时发布') && (this.state.timingTransmission)){
                confirm({
                    title: '当前状态无法设置定时器!',
                    onOk: ()=> {
                        this.state.timingTransmission = null;
                        this.onlySave();
                    },
                    onCancel() {
                        that.closeLoad();
                    },
                });
            }else{
                this.onlySave();
            }
        }else if(type === "publish"){
            this.publish();
        }else if(type === "revert"){
            this.getRevokeWeibo();
        }else if(type === "view"){
            this.closeLoad();
            window.open(this.publishUrl);
        }else if(type === "delete"){
            this.deleteWeiBo()
        }else{
            Activiti.util.simpleChainedFn.apply(activiti,functions);
        }
    };

    publish()
    {
        let weiboId = this.weiboId;
        let content = this.state.content;
        let picUrlsStr = "";
        let picList = this.state.fileList;
        for(let i = 0; i < picList.length; i++)
        {
            let pic = picList[i];
            if(pic.response)
            {
                picUrlsStr += pic.response.url + ",";
            }else {
                picUrlsStr += pic.url + ",";
            }
        }

        let tagsStr = "";
        if(this.editableTagGroup)
        {
            let tagsList = this.editableTagGroup.state.tags;
            for(let i = 0; i < tagsList.length; i++)
            {
                tagsStr += tagsList[i] + ",";
            }
        }

        if(content.trim() === "")
        {
            message.error("请输入微博正文");
            this.closeLoad();
            return;
        }

        if(content.length > 2000)
        {
            message.error("微博正文不能大于2000字");
            this.closeLoad();
            return;
        }
        taskPublishDate=this.state.timingTransmission;
       let touTiaoArticle=this.state.touTiaoArticleInfor.cover?this.state.touTiaoArticleInfor:null;
        if(this.state.currentData.statusName === '定时发布'){
            //定时发布再次点击发布,取消定时保存(后台取消定时器)
            taskPublishDate=null;
        }
        saveWeibo(weiboId, content, this.state.mediaCode, picUrlsStr, tagsStr,this.statusName,taskPublishDate,touTiaoArticle,(data)=>{
            if(data && data.id > 0)
            {
                this.weiboId = data.id;
                let pushObj = {
                    "serviceId":this.state.weiboId,
                    "mediaCode": this.state.mediaCode,
                    "userAccount":this.currentUser.account
                };
                publishWeibo(JSON.stringify(pushObj), (data)=>{
                    if(data)
                    {
                        message.success(data);
                        this.closeLoad();
                        this.refreshList();
                        this.closeModal();
                    }
                });
            }
        });
    }

    remarks;
    textareaHandleOk = () =>{
        let remarks = this.remarks.state.value;
        if(remarks && remarks !== "")
        {
            let callbackValue ={};
            callbackValue.remarks = remarks;
            callbackValue.type = this.callbackType;
            this.callback(callbackValue);
            this.setState({
                textareaModalVisible : false
            })
        }else {
            message.error("请填写备注");
            this.closeLoad();
        }
    };

    textareaHandleCancel = () =>{
        this.remarks.setState({
            value: ""
        })
        //关闭窗口
        this.setState({
            textareaModalVisible : false
        });
        this.closeLoad();
    };

    initWeiboData()
    {
//        console.log(this.weiboId,this.props.touTiaoParms);
        //头条文章编辑逻辑
       if(this.props.touTiaoParms.touTiaoArticle&&this.props.touTiaoParms.touTiaoArticle.cover){
           let touTiaoParms=this.props.touTiaoParms;
           this.state.isTouTiaoArticle=true;
           this.state.touTiaoArticleInfor=touTiaoParms.touTiaoArticle;
           this.state.tags= touTiaoParms.labelNames;
           this.state.timingTransmission=touTiaoParms.timingTransmission;
           this.state.content=touTiaoParms.content;
           this.state.currentData={...touTiaoParms};
           this.state.fontSize=touTiaoParms.content.length;
           if( this.props.weiboId>0){
               this.weiboId=touTiaoParms.initWeiBoId;
               this.statusName=touTiaoParms.statusName;
               this.state.weiboUserName=touTiaoParms.submitter;
               this.publishUrl=touTiaoParms.publishUrl;
               this.weibo_mid=touTiaoParms.weibo_mid;
               actInit(touTiaoParms,this);
           }else{
               this.weiboId=0;
               actInit(null,this);
           }
           this.setState({
           });
       } else{
           if(this.weiboId > 0)
           {
               if(!this.props.userInfo){
                   getUserInfo(this.state.mediaCode, (data)=>{
                       if(data)
                       {
                           if(data.profile_url && data.profile_url !== "")
                           {
                               this.state.userInfo=data;
                              /* this.domain = "https://www.weibo.com/"+data.profile_url;
                               this.setState({
                                   isAuth : true
                               });*/
                           }else{
                               this.state.userInfo={};
                               /*this.setState({});
                               message.error("当前微博无法使用，请先认证");*/
                           }
                       }else{
                           this.state.userInfo={};
                          /* this.setState({});
                           message.error("当前微博无法使用，请先认证");*/
                       }
                   });

               }
               getWeiboByWeiboId(this.weiboId,(data)=>{
                   if(data)
                   {
                       let newFileList = [];
                       this.statusName = data.statusName;
                       this.publishUrl = (data.touTiaoArticle && data.touTiaoArticle.url)? data.touTiaoArticle.url : data.publishUrl;
                       this.weibo_mid = data.weibo_mid;
                       if(data.picUrls)
                       {
                           for(let i = 0; i < data.picUrls.length; i++)
                           {
                               let picFile = {
                                   uid: i,
                                   name: '',
                                   status: 'done',
                                   url: data.picUrls[i]
                               };
                               newFileList.push(picFile);
                           }
                       }
                       let newState = this.formatContent(data.content);
                       if(data.touTiaoArticle){
                           this.state.isTouTiaoArticle=true;
                           this.state.touTiaoArticleInfor=data.touTiaoArticle;
                       }
                       this.state.currentData=data;
                       this.setState({
                           ...newState,
                           fileList: newFileList,
                           tags: data.labelNames,
                           weiboUserName : data.submitter,
                           timingTransmission:data.taskPublishDate&&data.taskPublishDate.time?utils.formatDate(data.taskPublishDate.time):'',
                       });
                       this.uploadfileNum = newFileList.length;
                       actInit(data,this);
                   }
               });
           }else {
               actInit(null,this);
           }
       }

        this.initEmotionsDataSource();
    }

    isupload = true;
    uploadfileNum = 0; //上传的图片个数计数开始值
    uploadfileMaxNum = 9; //允许上传的图片最大数

    uploadProps = {
        name: 'file',
        action: '/cm-sites-pms/ueditor/control?action=uploadimage',
        headers: {
            authorization: 'authorization-text',
        },
        data:{dataSource:7},
        multiple:true,
        showUploadList:false,
        onChange:({fileList})=>
        {
            if(this.isupload)
            {
                this.setState({fileList});
            }else {
                this.uploadfileNum = this.state.fileList.length;
                this.uploadPicturesWall.setState({fileList:this.state.fileList});
            }
        },
        beforeUpload: file => {
            this.uploadPicturesWall.setState({
                fileList:this.state.fileList
            })
            const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif';
            if (!isJpgOrPng) {
                message.error("请上传后缀名为jpg、png或gif的图片");
            }
            const isLt5M = file.size / 1024 / 1024 < 5;
            if (!isLt5M) {
                message.error("请上传小于5M的图片");
            }

            this.uploadfileNum++;
            let isOverstep = false;
            if(this.uploadfileNum > this.uploadfileMaxNum)
            {
                message.error("最多上传"+this.uploadfileMaxNum+"张照片");
                isOverstep = true;
            }

            if(!(isJpgOrPng && isLt5M) || isOverstep)
            {
                this.isupload = false;
                this.uploadfileNum = 0;
                return false;
            }
        },
    };

    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            content: nextProps.content,
        })
    }

    handleRemove = async file => {
        const index = this.state.fileList.indexOf(file);
        const newFileList = this.state.fileList.slice();
        newFileList.splice(index, 1);
        this.setState({
            fileList: newFileList
        });
        if(this.uploadPicturesWall)
        {
            this.uploadPicturesWall.setState({
                fileList: newFileList
            })
        }
    };

    getEmotionType()
    {
        let types = [];
        let emotionTypes = this.state.emotionsDataSource;
        emotionTypes.sort(sortBy('indexnum', false, parseInt));
        for(let i = 0; i < emotionTypes.length; i++)
        {
            let emotionType = emotionTypes[i];
            types.push(<TabPane tab={emotionType.category} key={emotionType.indexnum}>
                <table>
                    <tbody>
                    {
                        this.setEmotions(emotionType.emotion).map(tr=>{
                            return <tr key={uuid()}>
                                {tr.map(td => {
                                    return <td key={uuid()} width={36} height={34} align={"center"} style={{border:"1px solid #e8e8e8"}}>{td}</td>;
                                })}
                            </tr>
                        })
                    }
                    </tbody>
                </table></TabPane>);
        }
        return types;
    }

    setEmotions(emotions)
    {
        let rowNum = 15; //一行显示15个
        let tdComponents = [];
        let saveIndex = 1;
        let tdComponent = [];
        for(let i = 0; emotions && i < emotions.length; i++)
        {
            let emotion = emotions[i];
            tdComponent.push(<img width={26} style={{padding:"2px", cursor:"pointer"}} onClick={this.insertEmotion.bind(this,emotion)} title={emotion.value} src={emotion.icon}/>);
            if(saveIndex == (rowNum))
            {
                tdComponents.push(tdComponent);
                tdComponent = [];
                saveIndex = 0;
            }else {
                if(i == (emotions.length-1))
                {
                    tdComponents.push(tdComponent);
                }
            }
            saveIndex++;
        }
        return tdComponents;
    }

    insertEmotion(emotion){
        let newValue = this.contentWapper.insetIntoTextArea(emotion.value);
        this.setContent(newValue);
    }

    initEmotionsDataSource(){
        getAllEmotionsList(this.state.mediaCode,this.state.type,(data)=>{
            if(data && data.length && data.length > 0)
            {
                this.setState({
                    emotionsDataSource: data,
                });
            }
        });
    }

    renderEmotionsDataSource(){
        if(this.state.emotionsDataSource.length === 0){
            return <Empty/>
        }
        return (<div style={{width:"440px"}}>
            <Tabs type="line" size="small" tabBarGutter={0}>
                {
                    this.getEmotionType().map(etype=>{
                        return etype;
                    })
                }
            </Tabs>
        </div>);
    }

    closeModal()
    {
        if(this.fatherObj)
        {
            this.fatherObj.setState({
                visible: false,
                iconLoading: false
            });
        }
    }

    uploadPicturesWall;
    weiboPicturesWall;
    renderUploadImage(){
        return (
            <div>
                <Upload {...this.uploadProps} ref={(that)=>this.uploadPicturesWall=that}>
                    <Button icon={"upload"} onClick={this.closeUpload.bind(this)}>本地上传 </Button>
                </Upload>
                {/*<button>从资源库选择</button>*/}
            </div>
        );
    }
    closeUpload()
    {
        this.isupload = true;
        this.setState({
            uploadVisible: false,
        });
    }

    handleUploadVisibleChange = uploadVisible => {
        this.setState({uploadVisible});
    }

    setContent(newValue){
        this.setState(this.formatContent(newValue));
    }

    formatContent(newValue){
        if(newValue.length > 2000)
        {
            return {
                content : newValue,
                fontSize: newValue.length - 2000,
                showNowStr : <span style={{color:"red"}}>超过</span>
            };
        }else
        {
            return{
                content : newValue,
                fontSize: newValue.length,
                showNowStr : <span>输入</span>
            };
        }
    }

    userInput;
    setUserName()
    {
        let username = this.userInput.state.value;
        if(username && username.trim() !== "")
        {
            let newValue = this.contentWapper.insetIntoTextArea("@"+username);
            this.setContent(newValue);
            this.userInput.state.value = "";
            this.setState({
                userNameVisible: false,
            });
        }else {
            message.error("请输入用户名");
        }
    }

    handleUserNameVisibleChange = userNameVisible => {

        // if (userNameVisible) {
        //     let body = {
        //         mediaCode: this.state.mediaCode,
        //         keyword: '',
        //     };
        //     actions.seachUser(body, (data) => {
        //         if (data.length > 0) {
        //             this.setState({userNameData: data});
        //         }
        //     });
        // }
        this.state.openUserName = userNameVisible;
        this.setState({userNameVisible});
    };

    htInput;
    setHt()
    {
        let ht = this.htInput.state.value;
        if(ht && ht.trim() !== "")
        {
            let newValue = this.contentWapper.insetIntoTextArea("#"+ht+"#");
            this.setContent(newValue);
            this.htInput.state.value = "";
            this.setState({
                htVisible: false,
            });
        }else {
            message.error("请输入话题");
        }
    }
    handleHtVisibleChange = htVisible => {
        // if(htVisible){
        //     let body={category:null,query:null};
        //     actions.hotTopic(body,(data)=>{
        //         console.log(data)
        //         let Data=data.data;
        //         let moreTitle;
        //         if(Data&&Data.detail.length>0){
        //             if(Data.more_title&&Data.more_title.length>0){
        //                 moreTitle=[{
        //                     id: "",
        //                     name: "热门"
        //                 }].concat(Data.more_title);
        //             }else{
        //                 moreTitle=[];
        //             }
        //            // let moreTitle=Data.more_title;
        //             this.state.topicId='';
        //             this.setState({
        //                 topicData: Data.detail,
        //                 topicMenu:moreTitle
        //             });
        //         }
        //     });
        // }

        this.state.openTopic=htVisible;
        this.setState({htVisible});
    };

    videoInput;
    setVideo()
    {
        let videoUrl = this.videoInput.state.value;
        if(videoUrl && videoUrl.trim() !== "")
        {
            let newValue = this.contentWapper.insetIntoTextArea(videoUrl);
            this.setContent(newValue);
            this.videoInput.state.value = "";
            this.setState({
                videoVisible: false,
            });
        }else {
            message.error("请输入视频地址");
        }
    }
    handleVideoVisibleChange = videoVisible => {this.setState({videoVisible});};

    placeInput;
    setPlace()
    {
        let placeStr = this.placeInput.state.value;
        if(placeStr && placeStr.trim() !== "")
        {
            let newValue = this.contentWapper.insetIntoTextArea("#"+placeStr+"[地点]#");
            this.setContent(newValue);
            this.placeInput.state.value = "";
            this.setState({
                placeVisible: false,
            });
        }else {
            message.error("请输入定位");
        }
    }
    handlePlaceVisibleChange = placeVisible => {
        // if(placeVisible){
        //     let body={q:null};
        //     actions.location(body,(data)=>{
        //         let Data=data.data;
        //         if(Data&&Data.detail.length>0){
        //             this.setState({ placeData: Data.detail});
        //         }
        //     });
        // }

        this.state.openPlace=placeVisible;
        this.setState({placeVisible});
    };

    editableTagGroup;

    onlySave(callback)
    {
        let weiboId = this.state.weiboId;
        let content = this.state.content;
        let picUrlsStr = "";
        let picList = this.state.fileList;
        for(let i = 0; i < picList.length; i++)
        {
            let pic = picList[i];
            if(pic.response)
            {
                picUrlsStr += pic.response.url + ",";
            }else {
                picUrlsStr += pic.url + ",";
            }
        }

        let tagsStr = "";
        if(this.editableTagGroup)
        {
            let tagsList = this.editableTagGroup.state.tags;
            for(let i = 0; i < tagsList.length; i++)
            {
                tagsStr += tagsList[i] + ",";
            }
        }

        if(content.trim() === "")
        {
            message.error("请输入微博正文");
            this.closeLoad();
            return;
        }

        if(content.length > 2000)
        {
            message.error("微博正文不能大于2000字");
            this.closeLoad();
            return;
        }

        if(activiti && activiti.options.statusNameTemp !='发布'){
            //如果是流程中保存的话，只能发布保存定时器
            this.state.timingTransmission = "";
        }


        taskPublishDate=this.state.timingTransmission;
        let touTiaoArticle=this.state.touTiaoArticleInfor.cover?this.state.touTiaoArticleInfor:null;
        let that = this;
        saveWeibo(weiboId, content, this.state.mediaCode, picUrlsStr, tagsStr,this.statusName,taskPublishDate,touTiaoArticle,(data)=>{
            if(data && data.id > 0)
            {
                that.weiboId = data.id;
                if(callback){
                    data.statusName = activiti.options.statusNameTemp;
                    callback(data);
                }else {
                    that.activitiObj.updateServiceData(data,function () {
                        message.success("保存成功！");
                        that.closeModal();
                        that.refreshList();
                    })
                }
            }
        });
    }

    deleteWeiBo()
    {
        confirm({
            title: '是否要删除本条微博 ？',
            onOk: ()=>
            {
                this.closeLoad();
                deleteWeibo(this.weiboId,(data)=>{
                    if(data === "sucess")
                    {
                        this.closeModal();
                        message.success("删除成功");
                        this.props.removeWeibo(this.weiboId);
                    }else{
                        message.error("删除失败");
                    }
                });
                this.closeLoad();
            },
            onCancel:()=> {
                this.closeLoad();
            },
        });
    }

    getRevokeWeibo()
    {
        let that=this;
        confirm({
            title: '是否要撤稿本条微博 ？',
            onOk: ()=>
            {
                getRevokeWeibo(that.state.mediaCode, that.weibo_mid,(data)=>{
                    if(data)
                    {
                        let params = {
                            weiboId: that.weiboId,
                            statusName: "撤稿"
                        };
                        saveStatusName(params,(data)=>{
                            message.success("撤稿成功");
                            that.refreshList();
                            that.closeModal();
                        });
                    }else{
                        message.error("撤稿失败");
                    }
                    that.closeLoad();
                });
            },
            onCancel() {
                that.closeLoad();
            },
        });
    }

    contentWapper = new TextAreaWapper();

    syncTagsToSuperclass = (tags) =>
    {
        this.setState({tags});
    }

    openLoad = () =>{
        if(this.props.changeLoading){
            this.props.changeLoading(true);
        }
        this.setState({
            loading: true,
            iconLoading : true,
        })
    }

    closeLoad = () =>{
        if(this.props.changeLoading){
            this.props.changeLoading(false);
        }
        this.setState({
            loading: false,
            iconLoading : false,
        })
    }

    render()
    {
        //@ 用户名
        // const userNameOptions = this.state.userNameData.map(d =>{
        //  if(d&&d.screen_name){
        //      return (<Option key={d.screen_name}>
        //          <div title={d.screen_name} style={{
        //              width: 300,
        //              overflow: 'hidden',
        //              textOverflow: 'ellipsis',
        //              whiteSpace: 'nowrap'
        //          }}>{d.screen_name}</div>
        //      </Option>)
        //  }
        // } );
        //
        // //话题
        // const topicOptions = this.state.topicData.map(d => <Option key={d.keyword}>
        //     <div style={{display: 'flex'}}>
        //         <div title={d.display_name} style={{
        //             width: 300,
        //             overflow: 'hidden',
        //             textOverflow: 'ellipsis',
        //             whiteSpace: 'nowrap'
        //         }}>{d.display_name}</div>
        //         <div>{d.tail_text}</div>
        //     </div>
        // </Option>);
        // //定位
        // const options = this.state.placeData.map(d => <Option key={d.keyword}>
        //     <div style={{display: 'flex'}}>
        //         <div><img style={{width: 15, height: 15}} src={place} alt=""/></div>
        //         <div>
        //             <div>{d.display_name}</div>
        //             <div style={{
        //                 width: 300,
        //                 overflow: 'hidden',
        //                 textOverflow: 'ellipsis',
        //                 whiteSpace: 'nowrap'
        //             }}>{d.desc}</div>
        //         </div>
        //
        //     </div>
        //
        // </Option>);
        return (
            <Spin spinning={this.state.loading} >


                <div style={{height:119}}>
                    <WrappedWeiboContentForm setContent={this.setContent.bind(this)} contentWapper={this.contentWapper} fieldData={{content:{value:this.state.content}}} />
                </div>
                <div style={{float: 'right',position:'relative',marginTop:10}}>{
                    (this.state.timingTransmission && this.state.timingTransmission.length)>0? <span>定时发布：{this.state.timingTransmission}<Icon onClick={() => {
                        this.state.timingTransmission = '';
                        this.state.timeSelect=null;
                        this.setState({})
                    }} style={{cursor: 'pointer'}} type="close"/>&nbsp;&nbsp;</span>:null
                }

                    已{this.state.showNowStr}<span>{this.state.fontSize}</span>字
                </div>
                <div style={{clear:'both'}}/>
                <Scrollbars style={{height:500}}>
                {this.state.remarksContent&&this.state.remarksContent!==""?<span style={{color:"red"}}>退回：<span style={{color:"#000000"}}>{this.state.remarksContent}</span></span>:""}
                <div style={{zIndex:"9999999"}}>
                    <Popover placement="bottomLeft" content={this.renderEmotionsDataSource()} trigger="click" style={{width:"20px;"}} arrowPointAtCenter>
                        <img style={{cursor:"pointer",paddingLeft:"10px",paddingRight:"10px"}} src={"/cm-sites/images/mediaFusion/emotion.png"}/>
                    </Popover>
                    {this.state.isTouTiaoArticle?null:  <Popover placement="bottomLeft" content={this.renderUploadImage()} trigger="click" style={{width:"20px;"}} visible={this.state.uploadVisible} onVisibleChange={this.handleUploadVisibleChange} arrowPointAtCenter>
                        <img style={{cursor:"pointer",paddingLeft:"10px",paddingRight:"10px"}} src={"/cm-sites/images/mediaFusion/tupian.png"}/>
                    </Popover>}
                    <Popover placement="bottomLeft" content={
                        <div style={{width:"400px"}}>
                            {/*<Select style={{width: "300px"}}*/}
                            {/*        showSearch*/}
                            {/*        value={this.state.userNameValue}*/}
                            {/*        placeholder={this.props.userNameValue}*/}
                            {/*        defaultActiveFirstOption={false}*/}
                            {/*        showArrow={false}*/}
                            {/*        filterOption={false}*/}
                            {/*        // onSearch={this.handleSearchUserName}*/}
                            {/*        // onChange={this.handleChangeUserName}*/}
                            {/*        open={this.state.openUserName}*/}
                            {/*        notFoundContent={null}*/}
                            {/*>*/}
                            {/*    {userNameOptions}*/}
                            {/*</Select>*/}
                            <Input style={{width:"300px"}} ref={(that)=>this.userInput=that} placeholder="请输入用户名"/>
                            <Button style={{float:"right", marginLeft: 20}} type="primary" onClick={this.setUserName.bind(this)}>确定</Button>
                        </div>
                    } trigger="click" style={{width:"20px;"}} visible={this.state.userNameVisible} onVisibleChange={this.handleUserNameVisibleChange} arrowPointAtCenter>
                        <img style={{cursor:"pointer",padding:"10px"}} src={"/cm-sites/images/mediaFusion/aite.png"}/>
                    </Popover>
                    <Popover placement="bottomLeft" content={
                        <div style={{width:"400px"}}>
                            {/*<Select style={{width: "300px"}}*/}
                            {/*        showSearch*/}
                            {/*        value={this.state.topicValue}*/}
                            {/*        placeholder={this.props.topicValue}*/}
                            {/*        defaultActiveFirstOption={false}*/}
                            {/*        showArrow={false}*/}
                            {/*        filterOption={false}*/}
                            {/*        onSearch={this.handleSearchTopic}*/}
                            {/*        onChange={this.handleChangeTopic}*/}
                            {/*        open={this.state.openTopic}*/}
                            {/*        dropdownRender={menu => (*/}
                            {/*            <div>*/}
                            {/*                {*/}
                            {/*                    this.state.topicMenu.length>0?<Tabs activeKey={this.state.topicId} tabBarGutter={0} tabPosition={'top'}*/}
                            {/*                                                        onChange={(key) => {*/}
                            {/*                                                            this.tabChange(key)*/}
                            {/*                                                        }} style={{}}>*/}
                            {/*                        {this.state.topicMenu&&this.state.topicMenu.length>0&&this.state.topicMenu.map((item, i) => (*/}
                            {/*                            <TabPane tab={item.name} key={item.id}>*/}
                            {/*                            </TabPane>*/}
                            {/*                        ))}*/}
                            {/*                    </Tabs>:null*/}
                            {/*                }*/}

                            {/*                {menu}*/}
                            {/*            </div>*/}
                            {/*        )}*/}
                            {/*        notFoundContent={null}*/}
                            {/*>*/}
                            {/*    {topicOptions}*/}
                            {/*</Select>*/}
                             <Input style={{width:"300px"}} ref={(that)=>this.htInput=that} placeholder="请输入话题" />
                            <Button style={{float:"right", marginLeft: 20}} onClick={this.setHt.bind(this)} type="primary">确定</Button>
                        </div>
                    } trigger="click" style={{width: "20px;"}} visible={this.state.htVisible}
                             onVisibleChange={this.handleHtVisibleChange} arrowPointAtCenter>
                        <img style={{cursor: "pointer", padding: "10px"}}
                             src={"/cm-sites/images/mediaFusion/huati.png"}/>
                    </Popover>
                    {
                        this.state.isTouTiaoArticle?null: <Popover placement="bottomLeft" content={
                            <div style={{width:"385px"}}>
                                <p>请输入
                                    <a href={"http://video.sina.com.cn/"} target={"_blank"}>新浪播客</a>，
                                    <a href={"https://www.youku.com/"} target={"_blank"}>优酷网</a>，
                                    <a href={"https://www.tudou.com/"} target={"_blank"}>土豆网</a>，
                                    <a href={"https://www.ku6.com/index"} target={"_blank"}>酷6网</a>，
                                    <a href={"https://tv.sohu.com/"} target={"_blank"}>搜狐视频</a>，
                                    <a href={"https://www.56.com/"} target={"_blank"}>56网</a>，
                                    <a href={"https://www.iqiyi.com/"} target={"_blank"}>爱奇艺</a>，
                                    <a href={"https://www.ifeng.com/"} target={"_blank"}>凤凰网</a>，
                                    <a href={"http://www.yinyuetai.com/"} target={"_blank"}>音悦台</a>，
                                    <a href={"http://www.le.com/"} target={"_blank"}>乐视网</a>，
                                    <a href={"http://www.miaopai.com/"} target={"_blank"}>秒拍</a>
                                    等视频网站的视频播放页链接。</p>
                                <Input style={{width:"300px"}} ref={(that)=>this.videoInput=that} placeholder="请输入视频地址" /><Button style={{float:"right"}} onClick={this.setVideo.bind(this)} type="primary">确定</Button>
                            </div>
                        } trigger="click" style={{width:"20px;"}} visible={this.state.videoVisible} onVisibleChange={this.handleVideoVisibleChange} arrowPointAtCenter>
                            <img style={{cursor:"pointer",padding:"10px"}} src={"/cm-sites/images/mediaFusion/shipin.png"}/>
                        </Popover>
                    }

                    <Popover placement="bottom" content={
                        <div style={{width:"400px"}}>

                            {/*<Select style={{width: "300px"}}*/}
                            {/*        showSearch*/}
                            {/*        value={this.state.placeValue}*/}
                            {/*        placeholder={this.props.placeholder}*/}
                            {/*        defaultActiveFirstOption={false}*/}
                            {/*        showArrow={false}*/}
                            {/*        filterOption={false}*/}
                            {/*        onSearch={this.handleSearch}*/}
                            {/*        onChange={this.handleChange}*/}
                            {/*        open={this.state.openPlace}*/}
                            {/*        notFoundContent={null}*/}
                            {/*>*/}
                            {/*    {options}*/}
                            {/*</Select>*/}

                             <Input style={{width:"300px"}} ref={(that)=>this.placeInput=that} placeholder="定位" />
                            <Button style={{float:"right", marginLeft: 20}} onClick={this.setPlace.bind(this)} type="primary">确定</Button>
                        </div>
                    } trigger="click" style={{width: "20px;"}} visible={this.state.placeVisible}
                             onVisibleChange={this.handlePlaceVisibleChange} arrowPointAtCenter>
                        <img style={{cursor: "pointer", padding: "10px"}}
                             src={"/cm-sites/images/mediaFusion/dingwei.png"}/>
                    </Popover>
                </div>
                    <div style={{paddingLeft:"10px"}}>
                        标签
                        <EditableTagGroup type={'weibo'} syncTagsToSuperclass={this.syncTagsToSuperclass.bind(this)} ref={(that)=>this.editableTagGroup=that} tags={this.state.tags}/>
                    </div>
                    {this.state.isTouTiaoArticle?
                        <div style={{position:'relative'}} title={'点我去头条文章'}>
                           <img src={this.state.touTiaoArticleInfor.cover} style={{width:600,height:257,objectFit:'cover',cursor:'pointer'}} alt="" onClick={()=>{
                               this.clickTouTiaoImg();
                           }}/>
                           <div style={{fontSize:14,color:'white',position:'absolute',top:225,left:20}}>{this.props.userInfo?this.props.userInfo.screen_name:this.state.userInfo.screen_name}</div>
                            <div style={{width:600,background:'#f2f2f5',padding:'12px 16px 7px'}}>
                                <div style={{fontSize:22,color:'#333333',display:'-webkit-box',WebkitLineClamp:2,WebkitBoxOrient:'vertical',wordWrap:'break-word',overflow:'hidden'}}>{this.state.touTiaoArticleInfor.title}</div>
                                <div style={{fontSize:14,color:'#808080'}}>{this.state.touTiaoArticleInfor.summary}</div>
                            </div>
                           <div>

                           </div>
                        </div>
                        :<div style={{width:"440px",height:"230px"}}>
                        <div style={{paddingLeft:"230px",paddingTop:"0px",position:"absolute"}}></div>
                        {/*<Scrollbars style={{height:"220px",width:620}}>*/}
                        <WeiboPicturesWall handleRemove={this.handleRemove.bind(this)} ref={(that)=>this.weiboPicturesWall=that} listShow={false} fileList={this.state.fileList} />
                        {/*</Scrollbars>*/}
                    </div>}
                </Scrollbars>
                <div style={{position:"absolute",height:"38px",bottom:"0px",right: "10px",zIndex:1000,display:'flex'}} id={"btnArea"}>
                    {this.state.btns.map((btn, index)=>{
                        if(btn.name==='发布'){
                            return(
                                <div key={index} style={{marginRight: "10px", height: 32, display: 'flex'}}><Button

                                    loading={this.state.iconLoading}
                                    onClick={() => this.onClick(btn.type, btn.functions, this)}
                                    type={btn.name !== "发布" ? "normal" : "primary"}
                                >{btn.name}</Button>
                                    {/*<Popconfirm icon={null} title={*/}
                                    {/*    <div>*/}
                                    {/*        <DatePicker showTime placeholder="请选择定时时间" value={this.state.timeSelect}*/}
                                    {/*                    onChange={(value, dateString) => {*/}
                                    {/*                        this.timeOnChange(value, dateString)*/}
                                    {/*                    }}*/}
                                    {/*                    onOk={(value) => {*/}
                                    {/*                        this.timeOnOk(value)*/}
                                    {/*                    }}/>*/}
                                    {/*    </div>*/}
                                    {/*}*/}
                                    {/*            onConfirm={() => {*/}
                                    {/*                this.setState({*/}
                                    {/*                    timingTransmission: this.state.timeSelect.format('YYYY-MM-DD HH:mm:ss')*/}
                                    {/*                });*/}
                                    {/*            }}*/}
                                    {/*            onCancel={() => {*/}
                                    {/*                this.setState({*/}
                                    {/*                    timeSelect: null*/}
                                    {/*                });*/}
                                    {/*            }}*/}
                                    {/*            okText="确定"*/}
                                    {/*            cancelText="取消">*/}
                                    {/*    <div style={{*/}
                                    {/*        background: '#0050B3',*/}
                                    {/*        lineHeight: '32px',*/}
                                    {/*        borderRadius: 4,*/}
                                    {/*        marginLeft: '1px',*/}
                                    {/*        cursor: 'pointer'*/}
                                    {/*    }} onClick={() => {*/}
                                    {/*        this.setState({*/}
                                    {/*            timeVisible: true,*/}
                                    {/*        })*/}
                                    {/*    }}><img style={{width: 25, height: 25}} src={time} alt=""/></div>*/}
                                    {/*</Popconfirm>*/}
                                </div>
                            )

                        }else{
                            return <Button
                                key={uuid()}
                                loading={this.state.iconLoading}
                                onClick={() => this.onClick(btn.type, btn.functions, this)}
                                type={btn.name !== "发布"?(btn.name !='删除'?"normal":"danger"):"primary"}
                                style={{marginRight:"10px"}}>{btn.name}</Button>
                        }

                    })}
                    {

                        (this.currentUser.account === this.state.weiboUserName && this.weiboId > 0 && (this.statusName === "" || this.statusName === "草稿" ))?<Button
                            key={uuid()}
                            type={"danger"}
                            loading={this.state.iconLoading}
                            onClick={this.deleteWeiBo.bind(this)}
                            style={{marginRight:"10px"}}>删除</Button>:""
                    }
                    {/*{*/}
                    {/*    (this.currentUser.account === this.state.weiboUserName && this.weiboId > 0 &&(this.statusName === "发布"))?<Button*/}
                    {/*        key={uuid()}*/}
                    {/*        type={"danger"}*/}
                    {/*        loading={this.state.iconLoading}*/}
                    {/*        onClick={this.getRevokeWeibo.bind(this)}*/}
                    {/*        style={{marginRight:"10px"}}>撤稿</Button>:""*/}
                    {/*}*/}
                </div>
                <Modal
                    title={this.textareaModalTitle}
                    visible={this.state.textareaModalVisible}
                    onOk={this.textareaHandleOk}
                    onCancel={this.textareaHandleCancel}
                >
                    <TextArea ref={that => this.remarks = that} placeholder="请输入备注" maxLength={200}/>
                </Modal>

                <ChooseUserModal ref={"chooseUserModal"} onCancel={this.closeLoad}/>
            </Spin>
        );
    }

    //头条文章图片点击
    clickTouTiaoImg(){
        let toutiaoParms={
            ...this.state.currentData,//复制微博所有的数据，用特定需要的数据去覆盖
            initWeiBoId:this.state.weiboId,
            isAdd:false,
            content: this.state.content,
            labelNames: this.state.tags,//标签名字
            timingTransmission: this.state.timingTransmission,//定时发送的时间暂存
            touTiaoArticle:this.state.touTiaoArticleInfor,
        };
       // console.log(toutiaoParms);
        this.props.touTiaoParmsCallback&&this.props.touTiaoParmsCallback(toutiaoParms);

    }

    timeOnChange(value, dateString) {
        // console.log('Selected Time: ', value);
        //console.log('Formatted Selected Time: ', dateString);
        this.setState({timeSelect: value})
    }

    timeOnOk(value) {
        this.setState({timeSelect: value})
    }

    //@搜索人
    handleSearchUserName = value => {
        if (value) {
            value= value.slice(0,50);
            this.state.userNameValue=value;
            let body={
                mediaCode:this.state.mediaCode,
                keyword:value,
            };
            actions.seachUser(body,(data)=>{
                if(data.length>0){
                    this.setState({ userNameData: data});
                }
            });
        } else {
            this.setState({userNameData: []});
        }
    };

    handleChangeUserName = value => {
        let newValue = this.contentWapper.insetIntoTextArea('@'+value);
        this.setContent(newValue);
        this.state.userNameValue = '';
        this.setState({
            userNameVisible: false,
            openUserName: false
        });
    };


    //话题
    handleSearchTopic = value => {
        if (value) {
            value= value.slice(0,50);
            this.state.topicValue=value;
            let body = {category: this.state.topicId, query: value};
            actions.hotTopic(body, (data) => {
                let Data = data.data;
                if (Data && Data.detail.length > 0) {
                    this.setState({topicData: Data.detail});
                }
            })
        } else {
            this.setState({topicData: []});
        }
    };

    handleChangeTopic = value => {
        let newValue = this.contentWapper.insetIntoTextArea(value);
        this.setContent(newValue);
        this.state.topicValue = '';
        this.setState({
            openTopic: false,
            htVisible: false,
        });
    };

    tabChange(key) {
        this.state.topicId = key;
        let body = {category: key, query: null};
        actions.hotTopic(body, (data) => {
            let Data = data.data;
            if (key.length && key.length > 0) {
                if (Data && Data.more_detail.length > 0) {
                    this.setState({topicData: Data.more_detail});
                }
            } else {
                if (Data && Data.detail.length > 0) {
                    this.setState({topicData: Data.detail});
                }
            }


        })
    }

    //定位
    handleSearch = value => {
        if (value) {
           value= value.slice(0,50);
            this.state.placeValue=value;
            let body = {q: value};
            actions.location(body, (data) => {
                let Data = data.data;
                if (Data && Data.detail.length > 0) {
                    this.setState({placeData: Data.detail});
                }
            })
        } else {
            this.setState({placeData: []});
        }
    };

    handleChange = value => {
        console.log(value)
        let newValue = this.contentWapper.insetIntoTextArea(value);
        this.setContent(newValue);
        this.state.placeValue = '';
        this.setState({
            placeVisible: false,
            openPlace: false
        });
    };

}

EditWeiBo.defaultProps = {
    content: "",
    removeWeibo: ()=>{}
}

class WeiboContentForm extends Component{

    componentDidMount() {
        this.initFields(this.props);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.initFields(nextProps);
    }

    initFields(props) {
        const { fieldData } = props;
        const { setFields } = props.form;
        if(fieldData && this.fieldData !== fieldData){
            this.fieldData = fieldData;
            setFields(fieldData);
        }
    }

    handleContentChange(e){
        this.props.setContent(e.target.value);
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return (<Form>
            <Form.Item>
                {getFieldDecorator('content', {
                    rules: [{ required: true, message: '请输入微博正文!' }],
                })(
                    <TextArea style={{resize:"none"}} placeholder="请输入微博正文" rows={5} maxLength={2000}
                              onInput={(e)=>this.handleContentChange(e)}
                              ref={(that)=>this.props.contentWapper.dom = ReactDOM.findDOMNode(that)}
                              onBlur={(e)=>this.props.contentWapper.update(e)}
                    />
                )}
            </Form.Item>
        </Form>)
    }
}

const WrappedWeiboContentForm = Form.create()(WeiboContentForm);

class TextAreaWapper {

    dom;
    insertStartIndex;
    insertEndIndex;
    scrollPosition;

    lastLeaveTextAreaStyle = {
        insert: (value)=>{
            let newValue = this.dom.value.substring(0, this.insertStartIndex) + value + this.dom.value.substring(this.insertEndIndex, this.dom.value.length);
            this.dom.scrollTop = this.scrollPosition;
            this.insertStartIndex += value.length;
            this.insertEndIndex = this.insertStartIndex;
            this.dom.value = newValue;
            return newValue;
        },
        append: (value)=>{
            let newValue = this.dom.value + value;
            this.dom.value = newValue;
            return newValue;
        }
    };
    insertTextAreaStyle = "append";

    insetIntoTextArea = (value)=>{
        return this.lastLeaveTextAreaStyle[this.insertTextAreaStyle](value);
    };

    update = (e)=> {
        this.dom = e.target;
        if (this.dom.selectionStart || this.dom.selectionStart == '0') {
            this.insertTextAreaStyle = "insert";
            this.insertStartIndex = this.dom.selectionStart;
            this.insertEndIndex = this.dom.selectionEnd;
            this.scrollPosition = this.dom.scrollTop;
        } else {
            this.insertTextAreaStyle = "append";
        };
    }
}

function mapStateToProps(state){
    return {
        currentUser: state.systemReducer.currentUser
    }
}
export default connect(mapStateToProps)(EditWeiBo);